export enum STORE_ENUM {
  TOKEN_EXCHANGE = "token_exchange",
  AUTHENTICATE = "authenticate",
  SIGN_OUT = "signout",
  CASE_STATUSES = "case-statuses",
  MENU_ITEMS = "menu-items",
  USERNAME = "username",
  TOKEN_REFRESH = "refresh-token",
  CHARITY_REQUESTS = "charity-requests",
  TREATMENT_REQUESTS = "treatment-requests",
  WALLETS = "wallets",
  FINANCIAL_OPERATIONS = "financial-operations",
  SUPPORT_TICKETS = "support-tickets",
  USERS_REPORT_SIDEBAR = "users-report-sidebar",
  CASES_REPORT_SIDEBAR = "cases-report-sidebar",
  DONATIONS_REPORT_SIDEBAR = "donations-report-sidebar",
  SET_AUTHENTICATED = "set-authenticated",
  CUSTOM_AUTHENTICATE = "custom-authenticate",
  REPORTS_NESTED_SUB_ITEMS = "reports-nested-sub-items",
}
